
import { motion } from "framer-motion";
import { SubAccountManagement } from "@b2b/ui-components";

// import { Toaster } from "@b2b/ui-components";

const SubAccountManagementPage = () => {
  return (
      <div className="min-h-screen bg-background p-6">
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        className="bg-card border-b sticky top-0 z-20"
      >
      </motion.div>
      <SubAccountManagement />
    </div>
  );
};

export default SubAccountManagementPage;
